import React from 'react';
import './Home.css';
import logo2 from '../assets/logo2.png';

function Home({ language }) {
  const texts = {
    zh: {
      centerName: '游戏与艺术创研中心',
      centerNameEn: 'PKU Game And Art Research Center',
      institutionTitle: '机构简介',
      institutionContent: '游戏与艺术创研中心（简称VGARC）由中国高等学校影视学会于2023年批准成立，依托北京大学艺术学院主办，是中国高等院校第一批专注于电子游戏研究的学术机构，其前身是北京大学艺术学院"电子游戏历史与理论"工作坊。\n\n中心基于人文与艺术视角下的电子游戏研究为主线，自2020年起，组织了多场学术论坛和工作坊，汇聚了一批由艺术家、高校教师、独立学者、游戏从业者等组成的学术共同体，并与相关机构、媒体建立了良好的合作关系。\n\n中心依托北京大学深厚的学术积淀与人文传统，全面、集中的展开电子游戏的历史与理论研究，以及电子游在艺术、哲学、社会学、教育学、传播学等领域的影响与表达，倡导电子游戏与人工智能、军事、医学、体育竞技等领域的交叉研究，参与国际电子游戏研究交流，积累电子游戏研究成果，为深化对电子游戏的学术理解与文化评价提供理论支持，助力构建多元共生的中国电子游戏研究生态体系。',
      directorTitle: '主任寄语',
      directorContent: '21世纪的电子游戏正在重复文学在19世纪、电影在20世纪的命运。或者说，电子游戏正在经历小说、电影所经历过的一切。\n\n那么，电子游戏与小说、电影有什么相似性呢？我不想说他们都是艺术，而是：它们都是根据不同的指令在特性情境下提供着小剂量的合法幻觉。\n\n我们不能奢望可以通过一场电子游戏的学术会议，就扭转偏见，让讨厌它的人爱上它，或者痴迷它的人醒悟过来。恰恰相反，我们尝试说明：电子游戏与小说、电影一样，它既不遥远，也不纯洁。\n\n今天，电子游戏遍布在生活的每一个角落，只要你愿意，在每一个家庭中，在每一台智能手机上，无论你是否了解游戏，只要你想，随时可以快速地进入游戏，变成一个玩家。也完全可以不玩游戏，而不会影响你的生活。\n\n我们希望电子游戏的学术研究，可以让人们能以平静、平等、平常的心态正视电子游戏。'
    },
    en: {
      centerName: '游戏与艺术创研中心',
      centerNameEn: 'PKU Game And Art Research Center',
      institutionTitle: 'About the Center',
      institutionContent: 'The Video Game and Art Research Center (VGARC) was established in 2023 with approval from the China Association of Higher Education Film and Television, hosted by the School of Arts at Peking University. It is one of the first academic institutions in Chinese higher education dedicated to video game research, evolved from the "Video Game History and Theory" workshop at Peking University\'s School of Arts.\n\nFocusing on video game research from humanities and arts perspectives, the center has organized numerous academic forums and workshops since 2020, bringing together an academic community of artists, university faculty, independent scholars, and game industry professionals, while establishing strong collaborative relationships with relevant institutions and media.\n\nBuilding on Peking University\'s profound academic foundation and humanistic tradition, the center comprehensively conducts historical and theoretical research on video games, as well as their impact and expression in fields such as art, philosophy, sociology, education, and communication studies. It advocates for interdisciplinary research between video games and artificial intelligence, military, medicine, and sports competition, participates in international video game research exchanges, accumulates research achievements, provides theoretical support for deepening academic understanding and cultural evaluation of video games, and helps build a diverse and symbiotic Chinese video game research ecosystem.',
      directorTitle: 'Director\'s Message',
      directorContent: 'Video games in the twenty-first century are retracing the trajectory that literature followed in the nineteenth century and cinema in the twentieth. In other words, they are undergoing much of what novels and films once experienced.\n\nWhat, then, do games share with novels and films? Rather than simply calling them all “art,” I would say this: in specific contexts, each offers small, measured doses of legitimate illusion, guided by different sets of instructions.\n\nWe should not expect a single academic conference on video games to overturn entrenched biases—to make those who dislike them suddenly embrace them, or to make the enamored instantly sober. On the contrary, we aim to show that, like novels and films, video games are neither out of reach nor immaculate.\n\nToday, games permeate every corner of daily life. If you wish, in every household and on every smartphone, whether you “know” games or not, you can at any moment step into one and become a player. You can also choose not to play at all, without your life being diminished.\n\nOur hope is that scholarly research on video games will enable people to regard them with calmness and everyday normalcy.'
    }
  };

  const currentTexts = texts[language] || texts.en;

  return (
    <div className="home-page-main">
      {/* Hero Section - Simple and Blank */}
      <div className="hero-section">
        <div className="hero-container">
          <div className="hero-left">
            <h1 className="center-name-zh">{currentTexts.centerName}</h1>
            <h2 className="center-name-en">{currentTexts.centerNameEn}</h2>
          </div>
          <div className="hero-right">
            <div className="logo-container">
              <img src={logo2} alt="PKU-CCAVA Logo" className="hero-logo" />
            </div>
          </div>
        </div>
        
        {/* Grid Pattern */}
        <div className="grid-pattern"></div>
        
        {/* Scroll Down Indicator */}
        <div className="scroll-indicator" onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}>
          <svg className="chevron-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>

      {/* Content Section */}
      <div className="home-content-section">
        <div className="home-main-container">
          {/* 机构简介 Section */}
          <section className="institution-section">
            <div className="institution-container">
              <div className="institution-background-image"></div>
              <div className="institution-content">
                <h2 className="home-section-title">{currentTexts.institutionTitle}</h2>
                <div className="home-section-content">
                  {currentTexts.institutionContent.split('\n\n').map((paragraph, index) => (
                    <p key={index} className="home-content-paragraph">{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* 主任寄语 Section */}
          <section className="director-section">
            <div className="director-quote-container">
              <div className="director-background-image"></div>
              <div className="quote-content">
                <div className="quote-header">
                  <h2 className="home-section-title">{currentTexts.directorTitle}</h2>
                </div>
                <div className="quote-text">
                  <div className="quote-mark-left">"</div>
                  <div className="quote-mark-right">"</div>
                  <div className={`quote-body ${language === 'en' ? 'en' : ''}`}>
                    {language === 'en'
                      ? currentTexts.directorContent.split('\n\n').map((paragraph, index) => (
                          <p key={index} className="quote-paragraph en">{paragraph.trim()}</p>
                        ))
                      : currentTexts.directorContent.replace(/\n\n/g, ' ').split('. ').map((sentence, index, array) => (
                          <span key={index} className="quote-sentence">
                            {sentence.trim()}{index < array.length - 1 ? '. ' : ''}
                          </span>
                        ))
                    }
                  </div>
                </div>

              </div>
            </div>
          </section>
        </div>
        
        <footer className="home-game-footer">
          <div className="home-footer-text">
            © 2025 Video Game and Art Research Center, Peking University
          </div>
        </footer>
      </div>
    </div>
  );
}

export default Home;
